import React from "react";

const RefundPolicy = () => (
  <div className="p-60 max-w-4xl mx-auto">
    <h1 className="text-3xl font-bold mb-4">Refund & Cancellation Policy</h1>
    <p>Effective Date: July 26, 2025</p>

    <h2 className="text-xl font-semibold mt-6">1. Cancellations</h2>
    <p>
      Orders can be canceled within <strong>24 hours</strong> of payment
      confirmation.
    </p>

    <h2 className="text-xl font-semibold mt-4">2. Refund Eligibility</h2>
    <p>
      Refunds are applicable only if cancellation is within policy timeframe.
    </p>

    <h2 className="text-xl font-semibold mt-4">3. Processing Time</h2>
    <p>
      Refunds will be processed within <strong>5–7 business days</strong> via
      the original payment method.
    </p>

    <h2 className="text-xl font-semibold mt-4">4. Non-Refundable Cases</h2>
    <p>No refunds for digital services already delivered or consumed.</p>

    <h2 className="text-xl font-semibold mt-4">5. Contact</h2>
    <p>For refund requests,+9196662211365 with your order ID.</p>
  </div>
);

export default RefundPolicy;
